import { GenericError, IErrorDetails } from '@cian/peperrors/shared';

/**
 * @description
 * Ошибка контекста/состояния.
 * Если некое состояние системы не позволяет выполнить операцию (например, запрос), то бросаем ошибку GuardError.
 * Например: перед отправкой сообщения проверили, что сессия истекла - бросаем GuardError.
 */
export class GuardError extends GenericError {
  public constructor(configuration: { domain: string; message: string; details?: IErrorDetails }) {
    super({
      ...configuration,
      type: 'GuardError',
    }) /* istanbul ignore next */;

    Object.setPrototypeOf(this, GuardError.prototype);

    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, GuardError);
    } else {
      this.stack = new Error().stack;
    }
  }
}
